export const logged_user_routes = [
  {
    path: "/logged-user",
    component: () => import("../Main.vue"),
    name: "Meu Perfil"
  },
  {
    path: "/config",
    component: () => import("../Config.vue"),
    name: "Configuração"
  },
  {
    path: "/saque/:transaction_type",
    props: true,
    component: () => import("../Withdraw.vue"),
    name: "Saque"
  },
  {
    path: "/saque",
    component: () => import("../Withdraw.vue"),
    name: "Saques"
  },
  {
    path: "/ranking",
    component: () => import("../Ranking.vue"),
    name: "Ranking"
  },
  {
    path: "/transferencia/:transaction_type",
    props: true,
    component: () => import("../TransferBalance.vue"),
    name: "Transferência"
  },
  {
    path: "/solicitar-pagamento/:transaction_type",
    props: true,
    component: () => import("../RequestPay.vue"),
    name: "Solicitar Pagamento"
  },
  {
    path: "/pagar/:transaction_type",
    props: true,
    component: () => import("../GenerateCode.vue"),
    name: "Gerar Senha"
  },
  // {
  //   path: "/request-payment/:transaction_type",
  //   props: true,
  //   component: () => import("../Withdraw.vue"),
  //   name: "Sacar"
  // },
  // {
  //   path: "/request-payment",
  //   component: () => import("../WithdrawOption.vue"),
  //   name: "Opção de Saque"
  // },
  {
    path: "/deposito/:transaction_type",
    props: true,
    component: () => import("../Deposit.vue"),
    name: "Depositar"
  },
  {
    path: "/corretora",
    component: () => import("../Broker.vue"),
    name: "Corretora"
  }
];

export default {};
